import { useEffect } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Footer } from "@/components/landing/Footer";
import { AboutHero } from "@/components/about/AboutHero";
import { WhoWeAre } from "@/components/about/WhoWeAre";
import { Founder } from "@/components/about/Founder";
import { Experience } from "@/components/about/Experience";
import { HowWeWork } from "@/components/about/HowWeWork";
import { ProfessionalDelivery } from "@/components/about/ProfessionalDelivery";
import { AboutCTA } from "@/components/about/AboutCTA";

export default function About() {
  useEffect(() => {
    window.lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="about-page" className="bg-baseLight min-h-screen">
      <Navbar />
      <AboutHero />
      <WhoWeAre />
      <Founder />
      <Experience />
      <HowWeWork />
      <ProfessionalDelivery />
      <AboutCTA />
      <Footer />
    </div>
  );
}
